<template>
    <div class="">

        <p id="clear-selected-checked-list" class="d-inline-block">
            <span>Checked:</span>
            <span id="selected-checked-list"></span>
            <span class="ms-2 text-blue underline" style="color: #4c78dd; text-decoration: underline;">
                Clear?
            </span>
        </p>

        <!-- This has to be converted into an AJAX call then refresh the page afterwards -->
        <div class="row">
            <div class="col-md-3">
                <div class="form-group mb-4">
                    <label for="collection_date">
                        <strong>
                            Collection Date
                        </strong>
                    </label>
                    <div class="input-group datetime collection-date">
                        <span class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </span>
                        <input
                            class="form-control js-flatpickers"
                            placeholder="yyyy-mm-dd"
                            id="collection_date"
                            name="collection_date"
                            v-model="collectionDate"
                            type="date"
                        >
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="delivery_date">
                        <strong>
                            Delivery Date
                        </strong>
                    </label>
                    <div class="input-group datetime collection-date">
                        <span class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </span>
                        <input
                            class="form-control js-flatpickers"
                            placeholder="yyyy-mm-dd"
                            id="collection_date"
                            name="collection_date"
                            v-model="deliveryDate"
                            type="date"
                        >
                    </div>
                </div>
            </div>
        </div>

        <div class="btn-group">
            <button type="button" class="btn btn-sm btn-primary mt-3" @click="submitBulkUpdate()">
                Bulk Update Dates
            </button>
        </div>

    </div>

</template>

<script>

import axios from 'axios';
import flatpickr from 'flatpickr';
import Swal from "sweetalert2";

export default {

    props: {
        old: {
            type: String,
            required: false
        },
    },

    data () {
        return {
            checked: [],
            collectionDate: '',
            deliveryDate: '',
        }
    },

    mounted() {
        this.initialiseDatatable()

        if (this.checked.length === 0) {
            window.jQuery("#show-bulk-update").hide();
        }

        flatpickr('.js-date-picker', {
            altInput: true,
            altFormat: 'F j, Y',
            dateFormat: 'Y-m-d',
        });
    },

    updated() {
    },

    methods: {

        initialiseDatatable() {

            const table = window.jQuery("#datatable-jobs-list").DataTable();

            table.on( 'draw', () => {

                let jobSelects = document.querySelectorAll('.bulk-update-checkbox');

                jobSelects.forEach((jobSelect) => {

                    jobSelect.addEventListener('change', () => {

                        let value = JSON.parse(jobSelect.value)

                        if (jobSelect.checked) {
                            this.checked.push(value);
                        } else {
                            this.checked = this.checked.filter((c) => c.id !== value.id);
                        }

                        if (this.checked.length === 0) {
                            window.jQuery("#show-bulk-update").hide();
                        } else {
                            window.jQuery("#show-bulk-update").show();
                        }

                        let temp = [];
                        this.checked.forEach(function(c) {
                            temp.push(c.ref);
                        });

                        document.querySelector('#selected-checked-list').innerHTML = this.checked.filter((check) => check.ref)
                            .map((check) => check.ref)
                            .join(", ");

                    });
                });

                document.querySelector('#clear-selected-checked-list').addEventListener('click', () => {
                    document.querySelector('#selected-checked-list').innerHTML = '';
                    window.jQuery('.bulk-update-checkbox:checked').each(function(_, el) {
                        el.checked = false;
                    });
                    this.checked = [];
                    window.jQuery("#show-bulk-update").hide();
                });

            });

        },

        submitBulkUpdate() {

            var temp = [];
            let checked = window.jQuery('.bulk-update-checkbox:checked');

            checked.each(function(_, el) {
                let values = JSON.parse(el.value)
                temp.push(values.id);
            });

            const data = new FormData();
            data.append('collection_date', this.collectionDate);
            data.append('delivery_date', this.deliveryDate);
            data.append('ids', temp);

            axios.post(route('api.movements.jobs.bulk.update'), data)
            .then( response => {

                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: 'Dates Bulk Updated Successfully',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                }).then(() => {
                    window.location.reload();
                });

            }).catch( error => {

                if ( !error.response ) {
                    return;
                }

                let allErrors = '';

                if ( error.response?.data?.errors?.length > 0 ) {

                    const errorMessages = error.response.data.errors;

                    Object.entries(errorMessages).forEach(([, messages]) => {
                        messages.forEach(errorMessage => {
                            allErrors += '<p class="mb-0">' + errorMessage + '</p>';
                        });
                    });

                } else if ( error.response?.data?.message ) {
                    allErrors = error.response.data.message;
                }

                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Error Generating Price',
                    html: allErrors,
                    width: '600px',
                    confirmButtonText: 'Dismiss',
                    confirmButtonColor: '#dc3545 ',
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer);
                        toast.addEventListener('mouseleave', Swal.resumeTimer);
                    },
                });

            });
        },

    }
}
</script>
